/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class MapService {
        constructor(private $http: ng.IHttpService, private baseService: BaseService, private $q: ng.IQService, private $window: ng.IWindowService) { }

        public loadGoogleMaps(lang: string, apiKey: string) {
            var deferred = this.$q.defer();

            // Script loaded callback, send resolve
            (<any>this.$window).initMap = function () {
                var script = document.createElement('script');
                script.id = 'geoLocationMarker';
                script.src = '/dist/geolocation-marker.min.js';
                document.body.appendChild(script);
            };

            function loadScript() {
                if (document.getElementById('googleMapsScript') == null) {
                    var script = document.createElement('script');
                    script.id = 'googleMapsScript';
                    if (lang == 'se') lang = 'sv';
                    script.src = '//maps.googleapis.com/maps/api/js?libraries=places&language=' + lang + '&callback=initMap&key=' + apiKey;
                    document.body.appendChild(script);
                }
                else {
                    (<any>window).initMap();
                }
            }

            

            (<any>this.$window).initMapComplete = function () {
                deferred.resolve();
            };

            loadScript();

            return deferred.promise;
        }

        public lookupAddress(address: string) {
            address = encodeURIComponent(address);
            return this.baseService.get('geolocation/' + address.replace(/\./g, '') + '/coordinates');
        }

        public getStatistics() {
            return this.baseService.get('statistics').then(data => data.data);
        }

        public getMapSettings() {
            return [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "color": "#747e64"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c1c7b8"
                        },
                        {
                            "lightness": 5
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#313334"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#747e64"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#2e2e2e"
                        },
                        {
                            "weight": "3"
                        }

                    ]
                }
            ];
        }

    }

    MapService.$inject = ['$http', 'BaseService', '$q', '$window'];
    angular
        .module('eseebase')
        .service('MapService', MapService);
}